export const getGlobalWindow = (): Window => window;
